/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BlockFromAgentDeposits_user = {
    readonly id: string;
    readonly agentDepositsBlock: {
        readonly whenBlocked: string;
        readonly blockedBy: string;
        readonly blockReason: string;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"AgentDepositsBlockHistory_user">;
    readonly " $refType": "BlockFromAgentDeposits_user";
};
export type BlockFromAgentDeposits_user$data = BlockFromAgentDeposits_user;
export type BlockFromAgentDeposits_user$key = {
    readonly " $data"?: BlockFromAgentDeposits_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BlockFromAgentDeposits_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlockFromAgentDeposits_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActiveBlock",
      "kind": "LinkedField",
      "name": "agentDepositsBlock",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "whenBlocked",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockedBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockReason",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AgentDepositsBlockHistory_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '70952b42bd5698c8a8110c5ba97eac86';
export default node;
